import { cn } from "../../../helpers";
import styles from "./Badge.module.scss";

export type BadgeTone =
    | "neutral"
    | "info"
    | "success"
    | "warning"
    | "danger"
    | "purple";

export interface BadgeProps {
    content: React.ReactNode;
    tone?: BadgeTone;
    // Custom colors are for category colors (practice, inquiry method, status).
    // Prefer `tone` for everything else.
    textColor?: string;
    bgColor?: string;
    variant?: "soft" | "outline";
    className?: string;
    title?: string;
}

export function Badge({
    content,
    tone = "neutral",
    bgColor,
    textColor,
    variant = "soft",
    className,
    title,
}: BadgeProps) {
    // Nothing to show: don't render an empty pill
    if (content === null || content === undefined || content === "") {
        return null;
    }
    const hasCustomColor = Boolean(bgColor || textColor);
    return (
        <span
            className={cn(
                styles.badge,
                !hasCustomColor && styles[tone],
                variant === "outline" && styles.outline,
                className
            )}
            style={
                hasCustomColor
                    ? { backgroundColor: bgColor, color: textColor }
                    : undefined
            }
            title={title}
        >
            {content}
        </span>
    );
}
